import React, { useEffect, useState } from "react";

const fallbackImg = "/images/user-male.png"; // Place this in your public/images/ directory

function fixPictureUrl(url) {
  if (!url) return fallbackImg;
  let newUrl = url.trim();
  newUrl = newUrl.replace(/^http:\/\//i, "https://");
  newUrl = newUrl.replace(/([^:]\/)\/+/g, "$1");
  return newUrl;
}

function ManagementPage() {
  const [members, setMembers] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  // Always scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch("/api/Management")
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch data");
        return response.json();
      })
      .then((data) => {
        setMembers(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div
      style={{
        maxWidth: "1100px",
        margin: "0 auto",
        padding: "2rem 1rem 1.5rem 1rem",
        marginTop: "80px",
        minHeight: "80vh",
        boxSizing: "border-box"
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "2.2rem" }}>
        <h2
          style={{
            fontWeight: 800,
            fontSize: "4rem",
            marginBottom: "0.4em",
            letterSpacing: "0.03em"
          }}
        >
          विद्याभारती खेलपरिषद्
        </h2>
        {error && <p style={{ color: "red", fontWeight: 500 }}>{error}</p>}
        {loading && <p style={{ color: "#888", fontWeight: 400 }}>Loading...</p>}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "12px",
        }}
      >
        {!loading && !error && members.length === 0 && (
          <p style={{ textAlign: "center", width: "100%" }}>
            No management members found.
          </p>
        )}
        {members.map((member, idx) => (
          <div
            key={idx}
            style={{
              background: "#fff",
              borderRadius: "18px",
              boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
              padding: "24px 16px",
              minHeight: "320px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <img
              src={fixPictureUrl(member.picture) || fallbackImg}
              alt={member.name || "User"}
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                objectFit: "cover",
                marginBottom: "16px",
                background: "#f3f3f3",
                border: "2px solid #ddd",
              }}
              onError={e => {
                // Robust fallback for broken/missing image
                if (
                  e.target.src !== window.location.origin + fallbackImg &&
                  !e.target.src.endsWith(fallbackImg)
                ) {
                  e.target.onerror = null;
                  e.target.src = fallbackImg;
                }
              }}
            />
            <div
              style={{
                fontSize: "2.5rem",
                fontWeight: 700,
                color: "#222",
                margin: "0 0 8px 0",
                textAlign: "center",
                wordBreak: "break-word"
              }}
            >
              {member.name}
            </div>
            <div
              style={{
                fontSize: "2rem",
                fontWeight: 500,
                color: "#444",
                margin: "0 0 3px 0",
                textAlign: "center",
                wordBreak: "break-word"
              }}
            >
              {member.designation}
            </div>
            <div
              style={{
                fontSize: "1.75rem",
                color: "#666",
                textAlign: "center",
                margin: "0",
                wordBreak: "break-word"
              }}
            >
              {member.profession}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ManagementPage;
